<template>
  <div v-if="ribbons.length" class="promo-ribbons tw-grid tw-grid-rows-2 tw-gap-1 tw-mt-2">
    <div v-for="(ribbon, index) in ribbons" :key="index"
         :style="{'background': ribbon.RibbonBGColor, 'color': ribbon.RibbonTextColor}"
         class="promo-ribbons__ribbon-box lg:tw-px-px lg:tw-py-1 2xl:tw-py-2 2xl:tw-px-1.5 tw-flex">
      <div
        v-if="ribbon.RibbonIcon"
        class="promo-ribbons__button_icon tw-h-auto tw-flex tw-flex-col tw-justify-center tw-mr-1"
      >
        <img :src="getRibbonIcon(ribbon)" height="10">
      </div>
      <span class="promo-ribbons__ribbon-box--text tw-pr-px tw-py-0.5 2xl:tw-p-0">{{ ribbon.RibbonText | capitalize
        }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: "Ribbons",
  props: {
    ribbons: {
      type: Array,
      required: false,
      default: () => []
    },
    demoMode: {
      type: Boolean,
      required: false,
      default: false
    },
  },
  methods: {
    getRibbonIcon(ribbon) {
      return ribbon.RibbonIcon ? (this.demoMode ? require(`@/assets/icons/${ribbon.RibbonIcon}`) : ribbon.RibbonIcon) : null
    }
  },
  filters: {
    capitalize(val) {
      return val ? val.toUpperCase() : ''
    }
  }
}
</script>

<style lang="scss" scoped>
@import "Ribbons.scss";
</style>
